import React from 'react'
import './_home.scss'

const Home = () => {
  return (
    <div>  <main class="home">
    <h2>Hi! My Name Is</h2>
    <h1 class="home__name">
      Wednesday <span class="home__name--last">Addams</span>
    </h1>
    <h2>Full Stack Web Developer</h2>
  </main></div>
  )
}

export default Home